import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/** Referans ad düzenleme form şeması (020, 018 davranışı): nameTr zorunlu; nameEn opsiyonel. */
export const referansFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type ReferansFormValues = z.infer<typeof referansFormSchema>
